import React from 'react';
import { connect } from 'react-redux';

import { makeGetCurrentUser } from 'selectors/users';
import { makeGetCurrentTeam } from 'selectors/teams';
import { makeGetIsOnTrial, makeGetRemainingTrial } from 'selectors/billing';

import { showModal } from 'actions/modal';

import { getToday } from 'utils/date';
import { getPlanById } from 'utils/plan';

const AppUpgradeButton = ({ currentUserRole, currentPlanIsFree, isOnTrial, remainingTrial, currentPlan, history }) => {
    if (currentUserRole !== 'owner') {
        return null
    }

    if (!currentPlanIsFree && !isOnTrial) {
        return null;
    }

    const handleUpgradeClick = () => {
        if (currentPlan?.appSumo) {
            history.push({
                pathname: `/settings/team/current/billing`,
                state: {
                    closeUrl: history.getCurrentLocation().pathname
                } 
            });
            return;
        }

        showModal('SWITCH_PLAN');
    }

    return (
        <button className="btn btn-solid btn-small app-bar-btn" onClick={handleUpgradeClick}>
            {
                currentPlanIsFree ? '🚀 Upgrade your account' : `${remainingTrial} day${remainingTrial === 0 ? '' : 's'} left on trial`
            }
        </button>
    )
}

const makeMapStateToProps = () => {
    const getCurrentUser = makeGetCurrentUser();
    const getCurrentTeam = makeGetCurrentTeam();
    const getIsOnTrial = makeGetIsOnTrial();
    const getRemainingTrial = makeGetRemainingTrial();

    return ({ users, teams }) => {
        const currentUser = getCurrentUser(users);
        const currentTeam = getCurrentTeam(teams);
        const isOnTrial = getIsOnTrial(currentTeam);
        const remainingTrial = isOnTrial && getRemainingTrial(currentTeam, getToday().valueOf());
        const currentPlanId = currentTeam?.plan;
        const currentPlan = currentPlanId && getPlanById(currentPlanId);
        const currentPlanIsFree = currentPlan?.price?.free;

        return {
            currentUserRole: currentUser?.role,
            currentPlan,
            currentPlanIsFree,
            isOnTrial,
            remainingTrial
        }
    };
};

export default connect(makeMapStateToProps)(AppUpgradeButton);
